import { render, staticRenderFns } from "./ClientCreditsAdminAdd.vue?vue&type=template&id=d2e27c3c&scoped=true&"
import script from "./ClientCreditsAdminAdd.vue?vue&type=script&lang=js&"
export * from "./ClientCreditsAdminAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e27c3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAlert,VCardText,VSheet})
